export default class EducationActions {
  // namespace segments unit fetch
  static EDUCATION_SEGMENTS_FETCH_REQUEST = 'EDUCATION_SEGMENTS_FETCH_REQUEST'
  static EDUCATION_SEGMENTS_FETCH_SUCCESS = 'EDUCATION_SEGMENTS_FETCH_SUCCESS'
  static EDUCATION_SEGMENTS_FETCH_ERROR = 'EDUCATION_SEGMENTS_FETCH_ERROR'

  // namespace subjects unit fetch
  static EDUCATION_SUBJECTS_FETCH_REQUEST = 'EDUCATION_SUBJECTS_FETCH_REQUEST'
  static EDUCATION_SUBJECTS_FETCH_SUCCESS = 'EDUCATION_SUBJECTS_FETCH_SUCCESS'
  static EDUCATION_SUBJECTS_FETCH_ERROR = 'EDUCATION_SUBJECTS_FETCH_ERROR'

  // namespace authors unit fetch
  static EDUCATION_AUTHORS_FETCH_REQUEST = 'EDUCATION_AUTHORS_FETCH_REQUEST'
  static EDUCATION_AUTHORS_FETCH_SUCCESS = 'EDUCATION_AUTHORS_FETCH_SUCCESS'
  static EDUCATION_AUTHORS_FETCH_ERROR = 'EDUCATION_AUTHORS_FETCH_ERROR'

  // namespace publishers unit fetch
  static EDUCATION_PUBLISHERS_FETCH_REQUEST = 'EDUCATION_PUBLISHERS_FETCH_REQUEST'
  static EDUCATION_PUBLISHERS_FETCH_SUCCESS = 'EDUCATION_PUBLISHERS_FETCH_SUCCESS'
  static EDUCATION_PUBLISHERS_FETCH_ERROR = 'EDUCATION_PUBLISHERS_FETCH_ERROR'

  // namespace publishers unit fetch
  static GRADES_FETCH_REQUEST = 'GRADES_FETCH_REQUEST'
  static GRADES_FETCH_SUCCESS = 'GRADES_FETCH_SUCCESS'
  static GRADES_FETCH_ERROR = 'GRADES_FETCH_ERROR'

  // namespace twentyfirst competences fetch
  static TWENTYFIRST_COMPETENCES_FETCH_REQUEST = 'TWENTYFIRST_COMPETENCES_FETCH_REQUEST'
  static TWENTYFIRST_COMPETENCES_FETCH_SUCCESS = 'TWENTYFIRST_COMPETENCES_FETCH_SUCCESS'
  static TWENTYFIRST_COMPETENCES_FETCH_ERROR = 'TWENTYFIRST_COMPETENCES_FETCH_ERROR'

  // namespace inteligence scope fetch
  static INTELLIGENCE_SCOPE_FETCH_REQUEST = 'INTELLIGENCE_SCOPE_FETCH_REQUEST'
  static INTELLIGENCE_SCOPE_FETCH_SUCCESS = 'INTELLIGENCE_SCOPE_FETCH_SUCCESS'
  static INTELLIGENCE_SCOPE_FETCH_ERROR = 'INTELLIGENCE_SCOPE_FETCH_ERROR'

  // namespace onu groups
  static ONU_GROUPS_FETCH_REQUEST = 'ONU_GROUPS_FETCH_REQUEST'
  static ONU_GROUPS_FETCH_SUCCESS = 'ONU_GROUPS_FETCH_SUCCESS'
  static ONU_GROUPS_FETCH_ERROR = 'ONU_GROUPS_FETCH_ERROR'

  // namespace onu goals
  static ONU_GOALS_FETCH_REQUEST = 'ONU_GOALS_FETCH_REQUEST'
  static ONU_GOALS_FETCH_SUCCESS = 'ONU_GOALS_FETCH_SUCCESS'
  static ONU_GOALS_FETCH_ERROR = 'ONU_GOALS_FETCH_ERROR'

  // namespace publishers unit fetch
  static TWENTYFIRST_SKILLS_FETCH_REQUEST = 'TWENTYFIRST_SKILLS_FETCH_REQUEST'
  static TWENTYFIRST_SKILLS_FETCH_SUCCESS = 'TWENTYFIRST_SKILLS_FETCH_SUCCESS'
  static TWENTYFIRST_SKILLS_FETCH_ERROR = 'TWENTYFIRST_SKILLS_FETCH_ERROR'

  // namespace oost sels fetch
  static OOST_SUBJECTS_FETCH_REQUEST = 'OOST_SUBJECTS_FETCH_REQUEST'
  static OOST_SUBJECTS_FETCH_SUCCESS = 'OOST_SUBJECTS_FETCH_SUCCESS'
  static OOST_SUBJECTS_FETCH_ERROR = 'OOST_SUBJECTS_FETCH_ERROR'

  // namespace oost sels fetch
  static SELS_FETCH_REQUEST = 'SELS_FETCH_REQUEST'
  static SELS_FETCH_SUCCESS = 'SELS_FETCH_SUCCESS'
  static SELS_FETCH_ERROR = 'SELS_FETCH_ERROR'

  // segments unit fetch
  static fetchSegmentsRequest () {
    return {
      type: EducationActions.EDUCATION_SEGMENTS_FETCH_REQUEST
    }
  }
  static fetchSegmentsSuccess (payload) {
    return {
      type: EducationActions.EDUCATION_SEGMENTS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchSegmentsError (payload) {
    return {
      type: EducationActions.EDUCATION_SEGMENTS_FETCH_ERROR,
      payload
    }
  }

  // subjects unit fetch
  static fetchSubjectsRequest () {
    return {
      type: EducationActions.EDUCATION_SUBJECTS_FETCH_REQUEST
    }
  }
  static fetchSubjectsSuccess (payload) {
    return {
      type: EducationActions.EDUCATION_SUBJECTS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchSubjectsError (payload) {
    return {
      type: EducationActions.EDUCATION_SUBJECTS_FETCH_ERROR,
      payload
    }
  }

  // authors unit fetch
  static fetchAuthorsRequest () {
    return {
      type: EducationActions.EDUCATION_AUTHORS_FETCH_REQUEST
    }
  }
  static fetchAuthorsSuccess (payload) {
    return {
      type: EducationActions.EDUCATION_AUTHORS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchAuthorsError (payload) {
    return {
      type: EducationActions.EDUCATION_AUTHORS_FETCH_ERROR,
      payload
    }
  }
  // publishers unit fetch
  static fetchPublishersRequest () {
    return {
      type: EducationActions.EDUCATION_PUBLISHERS_FETCH_REQUEST
    }
  }
  static fetchPublishersSuccess (payload) {
    return {
      type: EducationActions.EDUCATION_PUBLISHERS_FETCH_SUCCESS,
      payload
    }
  }
  static fetchPublishersError (payload) {
    return {
      type: EducationActions.EDUCATION_PUBLISHERS_FETCH_ERROR,
      payload
    }
  }
  // publishers unit fetch
  static fetchGradesRequest () {
    return {
      type: EducationActions.GRADES_FETCH_REQUEST
    }
  }
  static fetchGradesSuccess (payload) {
    return {
      type: EducationActions.GRADES_FETCH_SUCCESS,
      payload
    }
  }
  static fetchGradesError (payload) {
    return {
      type: EducationActions.GRADES_FETCH_ERROR,
      payload
    }
  }
  // intelligence Scope unit fetch
  static fetchIntelligenceScopeRequest () {
    return {
      type: EducationActions.INTELLIGENCE_SCOPE_FETCH_REQUEST
    }
  }
  static fetchIntelligenceScopeSuccess (payload) {
    return {
      type: EducationActions.INTELLIGENCE_SCOPE_FETCH_SUCCESS,
      payload
    }
  }
  static fetchIntelligenceScopeError (payload) {
    return {
      type: EducationActions.INTELLIGENCE_SCOPE_FETCH_ERROR,
      payload
    }
  }
  // Onu Group unit fetch
  static onuGroupsRequest () {
    return {
      type: EducationActions.ONU_GROUPS_FETCH_REQUEST
    }
  }
  static onuGroupsSuccess (payload) {
    return {
      type: EducationActions.ONU_GROUPS_FETCH_SUCCESS,
      payload
    }
  }
  static onuGroupsError (payload) {
    return {
      type: EducationActions.ONU_GROUPS_FETCH_ERROR,
      payload
    }
  }
  // Onu Goals unit fetch
  static onuGoalsRequest () {
    return {
      type: EducationActions.ONU_GOALS_FETCH_REQUEST
    }
  }
  static onuGoalsSuccess (payload) {
    return {
      type: EducationActions.ONU_GOALS_FETCH_SUCCESS,
      payload
    }
  }
  static onuGoalsError (payload) {
    return {
      type: EducationActions.ONU_GOALS_FETCH_ERROR,
      payload
    }
  }
  // Twenty first competence unit fetch
  static twentyfirstCompetencesRequest () {
    return {
      type: EducationActions.TWENTYFIRST_COMPETENCES_FETCH_REQUEST
    }
  }
  static twentyfirstCompetencesSuccess (payload) {
    return {
      type: EducationActions.TWENTYFIRST_COMPETENCES_FETCH_SUCCESS,
      payload
    }
  }
  static twentyfirstCompetencesError (payload) {
    return {
      type: EducationActions.TWENTYFIRST_COMPETENCES_FETCH_ERROR,
      payload
    }
  }
  // Twenty first skills unit fetch
  static twentyfirstSkillsRequest () {
    return {
      type: EducationActions.TWENTYFIRST_SKILLS_FETCH_REQUEST
    }
  }
  static twentyfirstSkillsSuccess (payload) {
    return {
      type: EducationActions.TWENTYFIRST_SKILLS_FETCH_SUCCESS,
      payload
    }
  }
  static twentyfirstSkillsError (payload) {
    return {
      type: EducationActions.TWENTYFIRST_SKILLS_FETCH_ERROR,
      payload
    }
  }
  // oost subjects unit fetch
  static oostSubjectsRequest () {
    return {
      type: EducationActions.OOST_SUBJECTS_FETCH_REQUEST
    }
  }
  static oostSubjectsSuccess (payload) {
    return {
      type: EducationActions.OOST_SUBJECTS_FETCH_SUCCESS,
      payload
    }
  }
  static oostSubjectsError (payload) {
    return {
      type: EducationActions.OOST_SUBJECTS_FETCH_ERROR,
      payload
    }
  }
  // sels subjects unit fetch
  static selsRequest () {
    return {
      type: EducationActions.SELS_FETCH_REQUEST
    }
  }
  static selsSuccess (payload) {
    return {
      type: EducationActions.SELS_FETCH_SUCCESS,
      payload
    }
  }
  static selsError (payload) {
    return {
      type: EducationActions.SELS_FETCH_SUCCESS,
      payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/education/actions.js